import { doctors } from "../client/src/data/doctors";

function normalizeName(text: string): string {
  return text.normalize("NFKC").toLowerCase()
    .replace(/[\u064b-\u065f\u0640]/g, "")
    .replace(/[أإآ]/g, "ا").replace(/ى/g, "ي")
    .replace(new RegExp("[^\\p{L}\\p{N}\\s]", "gu"), " ").replace(/\s+/g, " ").trim();
}

const aliases = new Set<string>();
for (const doctor of doctors) {
  for (const name of [doctor.nameEn.replace(/^Dr\.?\s*/i, ""), doctor.nameAr.replace(/^د\.?\s*/, "")]) {
    const normalized = normalizeName(name);
    aliases.add(normalized);
    aliases.add(normalized.split(" ")[0]);
  }
}
for (const name of [
  "Ali Ahmed", "علي أحمد", "Farouk Khalaf", "Samira Mohammadi", "سميرة محمدي",
  "Fatma Salah", "فاطمة صالح", "Mohamed Khadour", "Mohammed Khadour",
  "Muhammad Khadour", "خضور", "Hasan Alhouri", "Hassan Alhouri", "حسن الحوري",
  "Mohammed Alsammarraie", "Mohamed Alsamarae", "السمرائي", "السامرائي",
  "Asma Ebied", "اسماء عبيد", "Rwaida Al Kubati", "رويدا الكبتي", "Aya Alsadi", "اية السعدي",
]) aliases.add(normalizeName(name));

const names = Array.from(aliases).filter(Boolean).sort((a, b) => b.length - a.length);
const unknownNamedDoctor = new RegExp(String.raw`\b[Dd][Rr]\.?\s+[\p{L}]|\b[Dd]octor\s+(?!(?:can|will|may|is|who|for|assesses|at|in|or|and|to|the|team|should|does|before)\b)[\p{Lu}]|(?:^|\s)د\s*[.:]\s*[\p{L}]|(?:الدكتور|الدكتورة|دكتور|دكتورة)\s*(?!(?:المختص|المعالج|المناسب|متخصص|في|من|يمكن|لدينا|الذي|التي)(?:\s|$))[\p{L}]`, "u");

/** Match only assistant output; visitor messages and archived records stay untouched. */
export function mentionsDoctorName(text: string): boolean {
  if (/\/doctors\/[\w%-]+|\/dr-[\w%-]+/i.test(text)) return true;
  const normalized = normalizeName(text);
  const value = ` ${normalized} `;
  // An explicit assistant display-name introduction is not a clinician recommendation.
  const assistantIntroduction = /^(?:hello i m|hello im|مرحبا انا)(?:\s|$)/i.test(normalized)
    && /clinic assistant|مساعد المركز/i.test(text)
    && !/\bdr\.?\s|\bdoctor\s|د\s*\.|الدكتور|الدكتورة|دكتور|دكتورة/i.test(text);
  if (!assistantIntroduction && names.some(name => value.includes(` ${name} `))) return true;
  return unknownNamedDoctor.test(text);
}
